import createClient from 'openapi-fetch';
import type { paths } from '../../../types/schema';
import baseUrl from '../../../utils/baseUrl';
import apiKey from '../../../utils/apiKey';
import getToken from '../../../utils/getToken';

export const client = createClient<paths>({ baseUrl: baseUrl() });

export function authHeaders() {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'X-API-KEY': apiKey()
  } as const;
}
